// extracted by mini-css-extract-plugin
export default {"h1":"LoginForm_h1__snlAy"};